import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'aav-icon',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'inline-flex shrink-0 items-center justify-center' },
  template: `
    <span
      class="material-symbols-outlined flex items-center justify-center leading-none"
      [style.font-size.px]="size"
      [style.width.px]="size"
      [style.height.px]="size"
      aria-hidden="true"
      >{{ name }}</span
    >
  `,
})
export class IconComponent {
  @Input() name = '';
  @Input() size = 20;
}
